import Toplistings from './Toplistings'

export default Toplistings
